import { stringify } from 'qs';
import request from '../request';
import { url } from '../service-utils';


export async function queryList(payload) {
  return request(`${url.salaryApi}/salary/manage/salarySheetList?${stringify(payload)}`);
}

export async function queryStatusList(payload) {
  return request(`${url.salaryApi}/salary/manage/salarySendStatus?${stringify(payload)}`);
}

/**
 * 删除
 * @param {Integer} id
 */
export async function salaryDelete(payload) {
  return request(`${url.salaryApi}/salary/manage/delete?${stringify(payload)}`);
}

/**
 * 撤回
 * @param {Integer} id
 */
export async function recall(payload) {
  return request(`${url.salaryApi}/salary/manage/revocation?${stringify(payload)}`);
}

/**
 * 提醒
 * @param {Integer} id
 */
export async function remind(payload) {
  return request(`${url.salaryApi}/salary/manage/remind?${stringify(payload)}`);
}

/**
 * 待发布 立即发布
 * @param {Integer} id
 */
export async function publish(payload) {
  return request(`${url.salaryApi}/salary/manage/publish?${stringify(payload)}&publishType=1`);
}


/**
 * 详情
 */

export async function detail(payload) {
  return request(`${url.salaryApi}/salary/manage/detail?${stringify(payload)}`);
}

/**
 * 查看工资条密码验证
 * @param {Object} params
 * @param {String} params.password
 */
export async function verifyPwd(params) {
  return request(`${url.salaryApi}/salary/privacy/salaryPasswordCheckout`, {
    method: 'POST',
    data: params,
  });
}
